import EventBus from "@lib/helpers/event-bus";
import { debounce } from "@qneyraud/q-utils";

const t = debounce(() => {
  EventBus.emit("resize-debounced");
}, 300);

export default () => {
  window.addEventListener("resize", () => {
    EventBus.emit("resize");
    t();
  });
};



// WEBPACK FOOTER //
// ./scripts/lib/plugins/resize.js